import { ReactComponent as ListIcon } from '../../images/book-library-svgrepo-com.svg';
import { FilterMatchMode } from "primereact/api";
import { Avatar } from "primereact/avatar";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { tipoTemplate } from "./CadastroPessoa";
import API from "../../api/API";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import * as messages from '../../utils/messages'
import { Button } from "primereact/button";
import { ArrendamentoType, LoteType, PessoaType, PlanoType, PlantioType, ImovelType, STATUS, PropriedadeSearchType } from "../../db/Orm";
import { IoPeopleOutline } from "react-icons/io5";
import { FiMapPin } from "react-icons/fi";
import { PiFarm, PiListChecks, PiReceipt, PiSparkle } from "react-icons/pi";
import { AxiosError } from "axios";
import { IconType } from "react-icons";
import { arrendatarioTemplate, propriedadeArrendamentoTemplate } from "./Aprovacao";
import Auth from "../../auth/Authenticator";

type DialogSearchProps = {
    visible: boolean
    setVisible: Function
    municipios: Array<any>
    pessoas: Array<PessoaType>
    propriedades: PropriedadeSearchType[]
    carregarPropriedades?: Function
    cultivos: Array<PlantioType>
    openMunicipio: Function
    openPessoa: Function
    openPropriedade: (propriedade: PropriedadeSearchType) => void
    openCultivo: Function
    arrendamentos?: Array<ArrendamentoType>
    carregarArrendamentos?: Function
    planos?: Array<PlanoType>
    carregarPlanos?: Function
}


export default function DialogSearch(props: DialogSearchProps) {
    const auth = Auth.useAuth();
    const getFirstTabIndex = () => {
        if (auth.hasPermission('monitorabahia.pesquisa_municipio')) return 0
        if (auth.hasPermission('monitorabahia.pesquisa_pessoas')) return 1
        if (auth.hasPermission('monitorabahia.pesquisa_propriedades')) return 2
        if (auth.hasPermission('monitorabahia.pesquisa_arrendamentos')) return 3
        //if (auth.hasPermission('monitorabahia.pesquisa_requerimentos')) return 4
        return 4
    }
    useEffect(() => {
        if (!props.visible) return
        setTabIndex(getFirstTabIndex())
        if (auth.hasPermission('monitorabahia.pesquisa_arrendamentos')) {
            props.carregarArrendamentos?.()
        }
        if (auth.hasPermission('monitorabahia.pesquisa_requerimentos')) {
            props.carregarPlanos?.()
        }
    }, [props.visible])
    const removerPessoa = (pessoa: PessoaType) => {
        const mensagemSucesso = () => {
            console.log('Removido fazenda (' + pessoa.id + '): ' + pessoa.nome_razao);
            messages.message(toastDialogPesquisar.current, pessoa.nome_razao + ' de id ' + pessoa.id + ' removido com sucesso!')
        }
        messages.confirmacao(toastDialogPesquisar.current, "Confirma a remoção de " + pessoa.nome_razao + '?', 'warn', () => { API.removePessoa(pessoa, mensagemSucesso) })
    }

    const removerPropriedade = (propriedade: any) => {
        const mensagemSucesso = () => {
            console.log('Removido fazenda (' + propriedade.id + '): ' + propriedade.nome_razao);
            messages.message(toastDialogPesquisar.current, propriedade.nome + ' de id ' + propriedade.id + ' removido com sucesso!')
        }
        messages.confirmacao(toastDialogPesquisar.current, "Confirma a remoção de " + propriedade.nome + '?', 'warn', () => { API.removePropriedade(propriedade, mensagemSucesso) })
    }
    const dataTableMunicipios = useRef<DataTable<any>>(null);
    const exportCSVMunicipios = () => {
        if (dataTableMunicipios.current !== null)
            dataTableMunicipios.current.exportCSV();
    };
    const dataTablePessoas = useRef<DataTable<any>>(null);
    const exportCSVPessoas = () => {
        if (dataTablePessoas.current !== null)
            dataTablePessoas.current.exportCSV();
    };
    const dataTablePropriedades = useRef<DataTable<any>>(null);
    const exportCSVPropriedades = () => {
        if (dataTablePropriedades.current !== null)
            dataTablePropriedades.current.exportCSV();
    };

    const paginatorRightMunicipios = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVMunicipios} size='small' />;
    const paginatorRightPessoas = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVPessoas} size='small' />;
    const paginatorRightPropriedades = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVPropriedades} size='small' />;


    const optionsMunicipios = (municipio: any) => (<><Button icon="pi pi-map-marker" severity="secondary" onClick={() => props.openMunicipio(municipio)} /></>)
    const optionsPessoas = (pessoa: PessoaType) => (<><Button icon="pi pi-user-edit" severity="secondary" onClick={() => props.openPessoa(pessoa, auth.hasPermission('monitorabahia.change_pessoa'))} />{/*<Button icon="pi pi-trash" onClick={() => removerPessoa(pessoa)} severity="danger" />*/}<Button icon="pi pi-key" onClick={() => API.resetarSenhaConfirmar(pessoa, toastDialogPesquisar.current)} severity="warning" /></>)
    const optionsPropriedades = (propriedade: PropriedadeSearchType) => (<><Button icon="pi pi-map-marker" severity="secondary" onClick={() => props.openPropriedade(propriedade)} />{/*<Button icon="pi pi-trash" onClick={() => removerPropriedade(propriedade)} severity="danger" />*/}{propriedade.doc_matricula && <Button icon="pi pi-file-pdf" onClick={() => window.open(propriedade.doc_matricula)} />}</>)

    type PropsIconStatus = {
        status: STATUS
    }

    const IconStatus = ({ status }: PropsIconStatus) => {
        //console.log('Status', status)
        switch (status) {
            case STATUS.NOVO:
                //console.log('NOVO')
                return <Avatar icon="pi pi-plus-circle" style={{ backgroundColor: '#9c27b0', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
            case STATUS.APROVADO:
                return <Avatar icon="pi pi-verified" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
            case STATUS.REPROVADO:
                return <Avatar icon="pi pi-times-circle" style={{ backgroundColor: '#DE2929', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
            case STATUS.ATUALIZADO:
                return <Avatar icon="pi pi-history" style={{ backgroundColor: '#D97706', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
            default:
                return <Avatar icon={<PiSparkle />} style={{ backgroundColor: '#9c27b0', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
        }
    }

    const statusPessoaTemplate = (pessoa: PessoaType) => {
        return (<IconStatus status={pessoa.status} />)
    }
    const statusFilterTemplate = (option: STATUS) => {
        return <div>
            <IconStatus status={option} /> {option === STATUS.APROVADO ? 'Aprovado' : option === STATUS.ATUALIZADO ? 'Atualizado' : option === STATUS.NOVO ? 'Novo' : option === STATUS.REPROVADO ? 'Reprovado' : ''}
        </div>
    }
    const statuses = [STATUS.APROVADO, STATUS.ATUALIZADO, STATUS.NOVO, STATUS.REPROVADO]
    const statusFilterElement = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown style={{ width: 40 }} value={options.value} options={statuses} onChange={(e: DropdownChangeEvent) => options.filterApplyCallback(e.value)} itemTemplate={statusFilterTemplate} placeholder="" showClear />;
    };
    const confirmFinalizarArrendamento = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, arrendamento: LoteType) => {
        messages.confirmacao(toastDialogPesquisar.current, 'Deseja finalizar arrendamento?', 'info', async () => {
            if (!arrendamento.id) {
                console.error('Arrendamento inválido')
                return
            }
            API.finalizarArrendamento(arrendamento.id)
                .then((resp) => {
                    console.log('Arrendamento finalizado', resp)
                    messages.message(toastDialogPesquisar.current, 'Arrendamento finalizado com sucesso!', 'success')
                    props.carregarArrendamentos && props.carregarArrendamentos()
                })
                .catch((error: AxiosError) => {
                    //console.log(error.toJSON())
                    messages.errorMessage(toastDialogPesquisar.current, 'Falha ao finalizar arrendamento:\n' + error.message)
                })
        })
    }

    const statusPropriedadeTemplate = (propriedade: ImovelType) => {
        return (<IconStatus status={propriedade.status} />)
    }
    const acoesArrendamentosTemplate = (arrendamento: LoteType) => {
        return <>
            <Button label='Ver Contrato' onClick={() => window.open(arrendamento.contrato || '')}></Button>
            {/* <Button label='Finalizar Arrendamento' onClick={(e) => { confirmFinalizarArrendamento(e, arrendamento) }}></Button> */}
        </>
    }
    const tabPanelHeaderTemplate: React.FC<{ icon: IconType, text: string }> = ({ icon: IconComponent, text }) => {
        return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><IconComponent style={{ marginRight: 5 }} />{text}</div>
    }
    const docPlanoTemplate = (req: PlanoType) => {
        // const controlesUrl = req.controles_assinado || req.controles
        // return <>
        //     {controlesUrl && <Button icon={<BiSolidFilePdf />} onClick={() => { window.open(controlesUrl) }} />}
        // </>
    }
    const docRequerimentosTemplate = (req: PlanoType) => {
        // const requerimentosUrl = req.requerimento_assinado || req.requerimento
        // return <>
        //     {requerimentosUrl && <Button icon={<BiSolidFilePdf />} onClick={() => { window.open(requerimentosUrl) }} />}
        // </>
    }
    const [filtersPessoas, setFiltersPessoas] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        nome_razao: { value: null, matchMode: FilterMatchMode.CONTAINS },
        // tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cpf_cnpj: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        // 'country.name': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        // representative: { value: null, matchMode: FilterMatchMode.IN },
        // For using custom filters, you must set FilterMatchMode.CUSTOM to matchMode.
        // activity: { value: null, matchMode: FilterMatchMode.CUSTOM },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
        // verified: { value: null, matchMode: FilterMatchMode.EQUALS }
        cidade: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    });

    const toastDialogPesquisar = useRef<Toast | null>(null)
    const [tabIndex, setTabIndex] = useState<number>(0)


    // const [resetandoSenha, setResetandoSenha] = useState(false)



    return <Dialog
        header={
            <div style={{ display: 'flex', alignItems: 'center', height: 10 }}>
                <ListIcon style={{ marginRight: 5 }} width={32} />
                PESQUISA
            </div>}
        visible={props.visible} style={{ width: 'min(1024px, 100dvw)' }} onHide={() => props.setVisible(false)}
        draggable={false} resizable={false}>
        <Toast ref={toastDialogPesquisar} position='center' />
        <TabView scrollable activeIndex={tabIndex} onTabChange={(e) => { setTabIndex(e.index) }}>
            {auth.hasPermission('monitorabahia.pesquisa_municipio') && <TabPanel header={tabPanelHeaderTemplate({ icon: FiMapPin, text: 'Municípios' })}>
                <DataTable ref={dataTableMunicipios} value={props.municipios} stripedRows
                    paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    filterDisplay="row" sortField="nome" sortOrder={1}
                    selectionMode="single" onSelectionChange={(e) => props.openMunicipio(e.value)}
                    dataKey='id' tableStyle={{ minWidth: '40rem' }}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} até {last} de {totalRecords}"
                    paginatorRight={paginatorRightMunicipios}
                >
                    <Column header='Código' field="id" filter />
                    <Column header='Nome' field="nome" filter />
                    <Column header='Microrregião' field="microrregiao.nome" filter filterField='microrregiao.nome' />
                    <Column header='Mesorregião' field="microrregiao.mesorregiao.nome" filter filterField='microrregiao.mesorregiao.nome' />
                    <Column header='Opções' body={optionsMunicipios} exportable={false} />
                </DataTable>
            </TabPanel>}
            {auth.hasPermission('monitorabahia.pesquisa_pessoas') && <TabPanel header={tabPanelHeaderTemplate({ icon: IoPeopleOutline, text: 'Pessoas' })}>
                <DataTable ref={dataTablePessoas} value={props.pessoas} stripedRows
                    paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    filterDisplay="row" filters={filtersPessoas} sortField="nome_razao" sortOrder={1}
                    selectionMode="single" onSelectionChange={(e) => props.openPessoa(e.value, false)}
                    dataKey='id' tableStyle={{ minWidth: '40rem' }}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} até {last} de {totalRecords}"
                    paginatorRight={paginatorRightPessoas}
                >
                    <Column header='Nome | Razão Social' field="nome_razao" filter showFilterMenu={false} />
                    <Column header='Tipo' body={tipoTemplate} />
                    <Column header='CPF | CNPJ' field="cpf_cnpj" filter showFilterMenu={false} />
                    <Column header='Município' field="cidade" filter showFilterMenu={false} />
                    <Column header='Status' field='status' body={statusPessoaTemplate} filter filterElement={statusFilterElement} showFilterMenu={false} />
                    <Column header='Opções' body={optionsPessoas} exportable={false} />
                </DataTable>
            </TabPanel>}
            {auth.hasPermission('monitorabahia.pesquisa_propriedades') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiFarm, text: 'Imóveis' })}>
                <DataTable
                    dataKey='id'
                    ref={dataTablePropriedades}
                    value={props.propriedades}
                    stripedRows
                    paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    filterDisplay="row" sortField="nome" sortOrder={1}
                    selectionMode="single" onSelectionChange={(e) => props.openPropriedade(e.value)}
                    tableStyle={{ minWidth: '40rem' }}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} até {last} de {totalRecords}"
                    paginatorRight={paginatorRightPropriedades}
                >
                    <Column header='Nome' field='nome' filter showFilterMenu={false} filterMatchMode='contains' />
                    <Column header='Município' field='municipio' body={(p) => props.municipios.filter((m: any) => m.id === p.municipio)[0].nome.toUpperCase() || ''} filter
                    showFilterMenu={false} filterMatchMode='startsWith'></Column>
                    <Column header='Proprietario' field='proprietario_nome' filter showFilterMenu={false} filterMatchMode='contains'/>
                    <Column header='Status' field='status' body={statusPropriedadeTemplate} filter filterElement={statusFilterElement} showFilterMenu={false} />
                    <Column header='Opções' body={optionsPropriedades} exportable={false} />
                </DataTable>
            </TabPanel>}
            {auth.hasPermission('monitorabahia.pesquisa_arrendamentos') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiReceipt, text: 'Arrendamentos' })}>
                <DataTable value={props.arrendamentos} filterDisplay="row">
                    <Column header='Propriedade' body={propriedadeArrendamentoTemplate} filter></Column>
                    <Column header='Arrendatario' body={arrendatarioTemplate} filter></Column>
                    <Column header='Inicio' field='arrendamento_inicio' filter></Column>
                    <Column header='Ações' body={acoesArrendamentosTemplate}></Column>
                </DataTable>
            </TabPanel>}
            {auth.hasPermission('monitorabahia.pesquisa_requerimentos') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiListChecks, text: 'Requerimentos' })}>
                <DataTable value={props.planos} stripedRows filterDisplay="row"
                    style={{ display: 'inline-flex' }} tableStyle={{ tableLayout: 'fixed' }}>
                    <Column header='Propriedade' field='propriedade.nome' filter filterMatchMode={FilterMatchMode.CONTAINS} showFilterMenu={false} headerStyle={{ width: '16rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
                    <Column header='Culturas' field='culturas' filter filterMatchMode={FilterMatchMode.CONTAINS} showFilterMenu={false} headerStyle={{ width: '11rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
                    <Column header={<>Responsável<br></br>Técnico</>} field='rt_nome' filter filterMatchMode={FilterMatchMode.CONTAINS} showFilterMenu={false} headerStyle={{ width: '13rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
                    {/* <Column header={<>Requerimento<br></br>de Plantio</>} body={docRequerimentosTemplate} headerStyle={{ width: '11rem' }}></Column>
                    <Column header={<>Plano de<br></br>Controle</>} body={docPlanoTemplate} headerStyle={{ width: '11rem' }}></Column> */}
                </DataTable>
            </TabPanel>}
        </TabView>
    </Dialog>
}